var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1926",
    "data-name": "Grupo 1926",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.584,
    height: 86.452,
    viewBox: "0 0 73.584 86.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    transform: "translate(0 29.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_205",
    "data-name": "Trazado 205",
    d: "M104.76,177.181l-1.4-1.3c0-.019-.019-.038-.038-.057L97.7,160.634a6.839,6.839,0,0,0-6.4-4.434H51.5a6.839,6.839,0,0,0-6.4,4.434l-5.566,15.019-2.113,1.755a9.3,9.3,0,0,0-3.321,7.075v21.887a6.885,6.885,0,0,0,6.887,6.811H45.1a6.744,6.744,0,0,0,6.736-6.755v-2.868H89.948v2.811a6.748,6.748,0,0,0,6.7,6.811H100.8a6.885,6.885,0,0,0,6.887-6.811V183.936A9.25,9.25,0,0,0,104.76,177.181ZM48.647,161.917a3,3,0,0,1,2.849-1.943H91.288a3,3,0,0,1,2.849,1.943l4.7,12.585H95.948a10.992,10.992,0,0,0-21.66,0H43.968ZM92.1,174.5H78.137a7.232,7.232,0,0,1,13.962,0ZM48.081,206.369a2.972,2.972,0,0,1-2.906,3.038h-4.17a3.1,3.1,0,0,1-3.113-3.038V202.86a7.146,7.146,0,0,0,3.113.7h7.075Zm55.848,0a3.1,3.1,0,0,1-3.113,3.038H96.7a2.971,2.971,0,0,1-2.962-2.981v-2.868h7.075a7.087,7.087,0,0,0,3.113-.7Zm-3.113-6.585H41.006a3.085,3.085,0,0,1-3.113-3.019V184.5a5.639,5.639,0,0,1,1.981-4.245l2.321-1.981h58.282l1.7,1.6a5.571,5.571,0,0,1,1.755,4.038v12.849h0A3.085,3.085,0,0,1,100.816,199.785Z",
    transform: "translate(-34.1 -156.2)",
    fill: "#003082"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100",
    transform: "translate(7.377 57.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_206",
    "data-name": "Trazado 206",
    d: "M86.785,303.2h-11.7a1.892,1.892,0,0,0-1.887,1.887V313.2a1.892,1.892,0,0,0,1.887,1.887h11.7a1.892,1.892,0,0,0,1.887-1.887v-8.113A1.892,1.892,0,0,0,86.785,303.2ZM84.9,311.313H76.974v-4.34H84.9Z",
    transform: "translate(-73.2 -303.2)",
    fill: "#86888b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    transform: "translate(50.773 57.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_207",
    "data-name": "Trazado 207",
    d: "M316.785,303.2h-11.7a1.892,1.892,0,0,0-1.887,1.887V313.2a1.892,1.892,0,0,0,1.887,1.887h11.7a1.892,1.892,0,0,0,1.887-1.887v-8.113A1.892,1.892,0,0,0,316.785,303.2Zm-1.887,8.113h-7.924v-4.34H314.9Z",
    transform: "translate(-303.2 -303.2)",
    fill: "#86888b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104",
    transform: "translate(27.396 63.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_208",
    "data-name": "Trazado 208",
    d: "M196.224,337.2H181.187a1.887,1.887,0,0,0,0,3.774h15.038a1.887,1.887,0,0,0,0-3.774Z",
    transform: "translate(-179.3 -337.2)",
    fill: "#003082"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106",
    transform: "translate(27.396 58.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_209",
    "data-name": "Trazado 209",
    d: "M196.224,312.2H181.187a1.887,1.887,0,1,0,0,3.773h15.038a1.887,1.887,0,1,0,0-3.773Z",
    transform: "translate(-179.3 -312.2)",
    fill: "#003082"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108",
    transform: "translate(4.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_107",
    "data-name": "Grupo 107",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_210",
    "data-name": "Trazado 210",
    d: "M119.994,11.094a1.882,1.882,0,0,0,2.038-1.717,1.678,1.678,0,0,0-.075-.679,11.6,11.6,0,0,0-4.491-6.377A12.9,12.9,0,0,0,110.089,0c-5.245,0-9.509,2.679-11.434,7.207H79.863A13.02,13.02,0,0,0,68.976.943a12.359,12.359,0,0,0-7.434,2.321,11.79,11.79,0,0,0-4.377,6.981,1.887,1.887,0,0,0,1.415,2.264,1.91,1.91,0,0,0,.566.038l6.151-.472a4,4,0,0,1,0,3.226l-6.189-.491a1.882,1.882,0,0,0-2.038,1.717,1.678,1.678,0,0,0,.075.679,11.994,11.994,0,0,0,11.924,8.6A11.979,11.979,0,0,0,80.5,18.528H99.221a12.5,12.5,0,0,0,10.717,6.283c.038,0,.075.019.113.019a12.5,12.5,0,0,0,7.434-2.283,11.909,11.909,0,0,0,4.453-6.868,1.877,1.877,0,0,0-1.377-2.283,1.608,1.608,0,0,0-.6-.057l-6.151.472a4,4,0,0,1,0-3.226Zm-8.7,5.849a1.864,1.864,0,0,0,1.641.736l4.264-.34a8.01,8.01,0,0,1-7.189,3.736,9.112,9.112,0,0,1-7.981-5.189,1.948,1.948,0,0,0-1.717-1.113H79.146a1.92,1.92,0,0,0-1.811,1.358,8.308,8.308,0,0,1-8.3,5.924,8.489,8.489,0,0,1-6.962-3.208l4.038.34a1.9,1.9,0,0,0,1.66-.736l.038-.057a7.676,7.676,0,0,0-.038-9.434,1.849,1.849,0,0,0-1.641-.717l-4.34.34a7.8,7.8,0,0,1,7.17-3.811,9.251,9.251,0,0,1,8.057,5.189A1.859,1.859,0,0,0,78.712,11H99.957a1.846,1.846,0,0,0,1.811-1.3,8.27,8.27,0,0,1,8.283-5.887,8.573,8.573,0,0,1,6.943,3.264l-4.038-.34a1.9,1.9,0,0,0-1.66.736l-.038.057A7.756,7.756,0,0,0,111.3,16.943Z",
    transform: "translate(-57.064)",
    fill: "#86888b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.d184322c002d00a28cd97103a55970bd.svg";
export { ForwardRef as ReactComponent };